<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-row align-h="between" style="margin-bottom: 1rem">
      <b-col><h5>水稻 - 葉稻熱病、穗稻熱病</h5></b-col>
      <b-col cols="auto" style="display: inline-flex;">
        <label style="margin-right: 0.5rem;">
          <b-button
            v-if="showmanage.add"
            style="float: right;"
            variant="warning"
            @click="showModal()"
            >新增</b-button
          >
        </label>
        <label style="margin-right: 0.5rem;">
          <b-button
            v-if="showmanage.add"
            style="float: right;"
            variant="primary"
            @click="object.ifshowmodal = true"
            >匯入Excel</b-button
          >
        </label>
        <label style="margin-right: 0.5rem;">
          <a
              href="https://agri-data.cyhg.gov.tw/uplode/114%e6%b0%b4%e7%a8%bb%e8%aa%bf%e6%9f%a5%e5%8c%af%e5%85%a5%e7%af%84%e4%be%8b%e6%aa%94.xlsx"
              download="水稻調查匯入範例檔.xlsx"
            >
              <b-button>範本下載</b-button>
            </a>
        </label>
      </b-col>
    </b-row>
    <b-row style="margin-bottom: 1rem">
      <b-col cols="10">
        <span>
          調查日期:
        </span>
        <span>
          <b-form-select
            style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
            v-model="object.yearlist.value"
            :options="object.yearlist.options"
          ></b-form-select>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          :items="object.items"
          :fields="checkeditfield"
          :busy="object.isBusy"
          responsive
          striped
          bordered
          outlined
          hover
        >
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #thead-top head-variant="dark">
            <b-tr class="thead-dark">
              <b-th>病蟲害</b-th>
              <b-th colspan="12">葉稻熱病</b-th>
              <b-th colspan="12">穗稻熱病</b-th>
              <b-th rowspan="3">其他</b-th>
              <b-th v-if="showmanage.delete" rowspan="3">功能</b-th>
            </b-tr>
            <b-tr class="thead-dark">
              <b-th>調查地點</b-th>
              <b-th colspan="6">豐收</b-th>
              <b-th colspan="6">菁埔</b-th>
              <b-th colspan="6">豐收</b-th>
              <b-th colspan="6">菁埔</b-th>
            </b-tr>
            <b-tr class="thead-dark">
              <b-th>調查日期/分級</b-th>
              <b-th>0</b-th>
              <b-th>1</b-th>
              <b-th>2</b-th>
              <b-th>3</b-th>
              <b-th>4</b-th>
              <b-th>5</b-th>
              <b-th>0</b-th>
              <b-th>1</b-th>
              <b-th>2</b-th>
              <b-th>3</b-th>
              <b-th>4</b-th>
              <b-th>5</b-th>
              <b-th>0</b-th>
              <b-th>1</b-th>
              <b-th>2</b-th>
              <b-th>3</b-th>
              <b-th>4</b-th>
              <b-th>5</b-th>
              <b-th>0</b-th>
              <b-th>1</b-th>
              <b-th>2</b-th>
              <b-th>3</b-th>
              <b-th>4</b-th>
              <b-th>5</b-th>
            </b-tr>
          </template>
          <template #cell(EDIT)="data">
            <b-button
              v-if="showmanage.delete"
              style="float: right; margin-left: 0.5rem;"
              variant="danger"
              @click="deleteProcess(data.item)"
              >刪除
            </b-button>
            <b-button
              v-if="showmanage.delete"
              style="float: right;"
              variant="warning"
              @click="showModal(data)"
              >編輯
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-modal
      v-model="object.ifshowmodal"
      id="modal-center"
      centered
      title="病蟲害資料Excel匯入"
      @ok="onExelUpload"
      @cancel="restFile"
    >
      <b-form-group label="檔案上傳">
        <b-form-file
          v-model="object.file"
          :state="Boolean(object.file)"
          placeholder="請選擇檔案"
          drop-placeholder="Drop file here..."
          browse-text="瀏覽"
          accept=".xls,.xlsx"
        ></b-form-file>
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="danger" @click="cancel()">
          取消
        </b-button>
        <b-button size="sm" variant="success" @click="ok()">
          上傳
        </b-button>
      </template>
    </b-modal>
      <!--新增/修改modal-->
    <template>
      <b-modal v-model="show" :title="titleType == 0 ? '新增病蟲害資料' : '修改病蟲害資料'" size="lg" id="v-center-modal" scrollable centered >
        
        <b-input-group
            style="width: 20vh;display: inline-flex; margin-right: 1rem;"
          >
            <b-input-group-prepend is-text>
              <b-icon icon="calendar3"></b-icon>
            </b-input-group-prepend>
            <datepicker
              v-model="timepicker.maxvalue"
              style="width: 13vh;"
              :min="twtimeparse(timepicker.minvalue)"
              :max="timepicker.max"
            ></datepicker>
          </b-input-group>
        <table class="table table-striped table-bordered table-hover">
          <thead class="thead-dark">
            <tr>
              <th class="input_align" scope="col" colspan="2">分級</th>
              <th class="input_align" scope="col">0</th>
              <th class="input_align" scope="col">1</th>
              <th class="input_align" scope="col">2</th>
              <th class="input_align" scope="col">3</th>
              <th class="input_align" scope="col">4</th>
              <th class="input_align" scope="col">5</th>
              <th class="input_align" scope="col">其他</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="input_align" rowspan="2" >葉稻熱病</td>
              <td class="input_align" >豐收</td>
              <td class="input_align">
                <input 
                  type="number"
                  style="width:60px;"
                  v-model.number="pests[0].S_HAR_0"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_HAR_1"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_HAR_2"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_HAR_3"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_HAR_4"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_HAR_5"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align" rowspan="4">
                <input
                  style="width:100px;"
                  v-model="pests[0].S_OTHER"
                  type="text"
                />
              </td>
            </tr>
            <tr>
              <td class="input_align" >菁埔</td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_CHI_0"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_CHI_1"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_CHI_2"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_CHI_3"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_CHI_4"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[0].S_CHI_5"
                  @keydown="onlyNumber"
                />
              </td>
            </tr>
            <tr>
              <td class="input_align" rowspan="2" >穗稻熱病</td>
              <td class="input_align" >豐收</td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_HAR_0"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_HAR_1"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_HAR_2"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_HAR_3"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_HAR_4"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_HAR_5"
                  @keydown="onlyNumber"
                />
              </td>
            </tr>
            <tr>
              <td class="input_align" >菁埔</td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_CHI_0"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_CHI_1"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_CHI_2"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_CHI_3"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_CHI_4"
                  @keydown="onlyNumber"
                />
              </td>
              <td class="input_align">
                <input
                  style="width:60px;"
                  type="number"
                  v-model.number="pests[1].S_CHI_5"
                  @keydown="onlyNumber"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <template #modal-footer>
          <b-button variant="primary" @click="save()">確定</b-button>
        </template>

      </b-modal>
    </template> 
  </b-container>

</template>

<script>
import datepicker from "@/components/Datepicker.vue";
export default {
  data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    // maxDate.setDate(date.getDate() + 1);
    const minDate = new Date(today);
    console.log(["getItem('Crop')",sessionStorage.getItem("Crop")])
    if(sessionStorage.getItem("Crop") != null) minDate.setDate(date.getDate() - 10);
    else minDate.setDate(date.getDate() - 30);
    var taiwanMinDate = minDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
      taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    taiwanMinDate[2] =
      taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      object: {
        items: [
          {
            CM_DATE: "110/1/25",
            f_0: 0,
            f_1: 4.8,
            f_2: 0.2,
            f_3: 0,
            f_4: 0,
            f_5: 0,
            g_0: 0,
            g_1: 4.9,
            g_2: 0.2,
            g_3: 0,
            g_4: 0,
            g_5: 0,
            h_0: 0,
            h_1: 0,
            h_2: 0,
            h_3: 0,
            h_4: 0,
            h_5: 0,
            i_0: 0,
            i_1: 0,
            i_2: 0,
            i_3: 0,
            i_4: 0,
            i_5: 0,
          },
        ],
        allitems: [],
        fields: [
          {
            key: "S_DATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_0",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_1",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_3",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_4",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_5",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_0",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_1",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_3",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_4",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_5",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_0_2",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_1_2",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_2_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_3_2",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_4_2",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_5_2",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_0_2",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_1_2",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_2_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_3_2",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_4_2",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_5_2",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_OTHER",
            label: "其他",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "EDIT",
            label: "功能",
            thClass: "hideheadr",
            visible: false,
          },
        ],
        fields2: [
          {
            key: "S_DATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_0",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_1",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_3",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_4",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_5",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_0",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_1",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_3",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_4",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_5",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_0_2",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_1_2",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_2_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_3_2",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_4_2",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_5_2",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_0_2",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_1_2",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_2_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_3_2",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_4_2",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_5_2",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_OTHER",
            label: "其他",
            thClass: "hideheadr",
            visible: true,
          },
        ],
        yearlist: {
          value: null,
          options: [],
        },
        perPage: 10,
        currentPage: 1,
        isBusy: true,
        ifshowmodal: false,
        updating: false,
        file: null,
      },
      formData: null,
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "資料管理",
          active: true,
        },
        {
          text: "病蟲害資料維護",
          active: true,
        },
      ],
      timepicker: {
        minvalue: taiwanMinDate.join("-"),
        maxvalue: taiwanMaxDate.join("-"),
        // minvalue: "110-07-12",
        // maxvalue: "110-07-15",
        max: maxDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
        min: minDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
      },
      showmanage: {
        show: false,
        add: false,
        edit: false,
        delete: false,
        count: 0,
      },
      show: false,
      titleType: 0,
      pestsDefault:[
        {
          S_DATE:"",
          S_NAME:"葉稻熱病",
          S_HAR_0:0,
          S_HAR_1:0,
          S_HAR_2:0,
          S_HAR_3:0,
          S_HAR_4:0,
          S_HAR_5:0,
          S_CHI_0:0,
          S_CHI_1:0,
          S_CHI_2:0,
          S_CHI_3:0,
          S_CHI_4:0,
          S_CHI_5:0,
          S_OTHER:"",
        },
        {
          S_DATE:"",
          S_NAME:"穗稻熱病",
          S_HAR_0:0,
          S_HAR_1:0,
          S_HAR_2:0,
          S_HAR_3:0,
          S_HAR_4:0,
          S_HAR_5:0,
          S_CHI_0:0,
          S_CHI_1:0,
          S_CHI_2:0,
          S_CHI_3:0,
          S_CHI_4:0,
          S_CHI_5:0,
          S_OTHER:"",
        }
      ],
      pests: [],
      apiRiceBlasYearList: (data) =>
        this.userRequest.post("API/Default/RiceBlasYearList", data),
      apiRiceBlastManagementList: (data) =>
        this.userRequest.post("API/Default/RiceBlastManagementList", data),
      apiDeleteRiceBlastbyDate: (data) =>
        this.userRequest.post("API/Default/DeleteRiceBlastbyDate", data),
      apiRiceBlastExcelUpload: (data) =>
        this.userRequest.post("API/Default/RiceBlastExcelUpload", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }),
      apiRiceBlastInsertUpdate: (data) =>
        this.userRequest.post("API/Default/RiceBlastInsertUpdate", data),
    };
  },
  created() {
    this.pests = JSON.parse(JSON.stringify(this.pestsDefault));
    this.checkLogin();
  },
  components: {
    datepicker,
  },
  computed: {
    checkeditfield() {
      return this.showmanage.delete == true
        ? this.object.fields
        : this.object.fields2;
    },
  },
  methods: {
    twtimeparse(item) {
      let tt = item.split("-");
      tt[0] = parseInt(tt[0]) + 1911;
      return tt.join("-");
    },
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      this.showmanage.count = 0;
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000022",
        fun: this.checkByPJIDshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000023",
        fun: this.checkByPJIDadd,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000024",
        fun: this.checkByPJIDedit,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000025",
        fun: this.checkByPJIDdelete,
      });
    },
    checkallpermission() {
      if (
        this.showmanage.show ||
        this.showmanage.add ||
        this.showmanage.delete
      ) {
        // window.addEventListener("resize", this.handleResize);
        // this.handleResize();
        this.init();
      } else {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      }
    },
    checkByPJIDshow(value) {
      this.showmanage.count++;
      if (value) this.showmanage.show = true;
    },
    checkByPJIDadd(value) {
      this.showmanage.count++;
      if (value) this.showmanage.add = true;
    },
    checkByPJIDedit(value) {
      this.showmanage.count++;
      if (value) this.showmanage.edit = true;
    },
    checkByPJIDdelete(value) {
      this.showmanage.count++;
      if (value) this.showmanage.delete = true;
    },
    init() {
      this.FunctionToken(this.getRiceBlasYearList, {});
    },
    save(){
      if(this.timepicker.maxvalue == "" || this.timepicker.maxvalue == null) {
        alert("請選擇調查日期");
        return;
      }
      this.pests[0].S_DATE = this.timepicker.maxvalue;
      this.pests[1].S_DATE = this.timepicker.maxvalue;
      this.pests[1].S_OTHER = this.pests[0].S_OTHER;
      this.FunctionToken(this.saveRiceBlast, { RICE_BLASTs: this.pests });
    },
    saveRiceBlast(data){
      console.log("saveRiceBlast",data);
      this.apiRiceBlastInsertUpdate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            alert("資料儲存成功");
            this.show = false;
            
            this.init();
            this.getdata();
          }
        })
        .catch((err) => console.warn(err));
    },
    getRiceBlasYearList(data) {
      this.apiRiceBlasYearList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            var data = JSON.parse(json.Data);
            this.object.yearlist.value = data[0];
            this.object.yearlist.options = data;
            // let obj = {
            //   YEAR: this.object.yearlist.value,
            // };
            // this.FunctionToken(this.getRiceBlastManagementList, obj);
          }
        })
        .catch((err) => console.warn(err));
    },
    getRiceBlastManagementList(data) {
      this.apiRiceBlastManagementList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            var data = JSON.parse(json.Data);
            this.object.items = data;
            this.object.isBusy = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    RiceBlastExcelUpload() {
      this.apiRiceBlastExcelUpload(this.formData)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Message == "失敗") {
            alert("匯入失敗！內容有誤，請修正後重新匯入");
            this.object.isBusy = false;
          }

          if (json.Status) {
            var data = JSON.parse(json.Data);
            if (data.status == "success") {
              alert("資料上傳成功");
              this.getdata();
            }
          }
        })
        .catch((err) => console.warn(err));
    },
    deleteRiceBlastbyDate(data) {
      this.apiDeleteRiceBlastbyDate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            alert("刪除成功");
            this.getdata();
            this.init();
          }
        })
        .catch((err) => console.warn(err));
    },
    onExelUpload() {
      const file = this.object.file;
      if (!file) {
        alert("請先選擇檔案");
        return;
      }

      const fileName = file.name || "";
      const fileType = file.type || "";
      const ext = fileName.includes(".")
        ? fileName.split(".").pop().toLowerCase()
        : "";
      const allowedExt = ["xls", "xlsx"];
      const allowedMimeTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (!allowedExt.includes(ext) && !allowedMimeTypes.includes(fileType)) {
        alert("僅允許上傳 xls、xlsx 檔案");
        this.object.file = null;
        return;
      }

      this.formData = new FormData();
      this.formData.append("Files", file);
      this.object.isBusy = true;
      this.FunctionToken(this.RiceBlastExcelUpload, {});
    },
    restFile() {
      this.formData = null;
      this.object.file = null;
    },
    deleteProcess(item) {
      if (confirm("確定要刪除此資料?")) {
        this.FunctionToken(this.deleteRiceBlastbyDate, {
          S_DATE: item.S_DATE,
        });
      }
    },
    getdata() {
      let obj = {
        YEAR: this.object.yearlist.value,
      };
      this.object.isBusy = true;
      this.FunctionToken(this.getRiceBlastManagementList, obj);
    },
    showModal(value){
      console.log("showModal",value);
      this.show = true;
      if(value == undefined){
        this.titleType = 0;
        this.pests = JSON.parse(JSON.stringify(this.pestsDefault));
      }
      else{
        this.titleType = 1;
        this.timepicker.maxvalue = value.item.S_DATE.replace("-","/");
        this.pests= null;
        this.pests =[
          {
            S_DATE: this.timepicker.maxvalue,
            S_NAME:"葉稻熱病",
            S_HAR_0:value.item.S_HAR_0,
            S_HAR_1:value.item.S_HAR_1,
            S_HAR_2:value.item.S_HAR_2,
            S_HAR_3:value.item.S_HAR_3,
            S_HAR_4:value.item.S_HAR_4,
            S_HAR_5:value.item.S_HAR_5,
            S_CHI_0:value.item.S_CHI_0,
            S_CHI_1:value.item.S_CHI_1,
            S_CHI_2:value.item.S_CHI_2,
            S_CHI_3:value.item.S_CHI_3,
            S_CHI_4:value.item.S_CHI_4,
            S_CHI_5:value.item.S_CHI_5,
            S_OTHER:value.item.S_OTHER,
          },
          {
            S_DATE: this.timepicker.maxvalue,
            S_NAME:"穗稻熱病",
            S_HAR_0:value.item.S_HAR_0_2,
            S_HAR_1:value.item.S_HAR_1_2,
            S_HAR_2:value.item.S_HAR_2_2,
            S_HAR_3:value.item.S_HAR_3_2,
            S_HAR_4:value.item.S_HAR_4_2,
            S_HAR_5:value.item.S_HAR_5_2,
            S_CHI_0:value.item.S_CHI_0_2,
            S_CHI_1:value.item.S_CHI_1_2,
            S_CHI_2:value.item.S_CHI_2_2,
            S_CHI_3:value.item.S_CHI_3_2,
            S_CHI_4:value.item.S_CHI_4_2,
            S_CHI_5:value.item.S_CHI_5_2,
            S_OTHER:value.item.S_OTHER,
          }
        ]
      }
      
    },
    onlyNumber(e) {
      if (['e', 'E', '+', '-'].includes(e.key)) {
        e.preventDefault();
      }
    }
  },
  watch: {
    "object.yearlist.value"() {
      this.getdata();
    },
    "showmanage.count"(val) {
      if (val == 3) {
        this.checkallpermission();
      }
    },
  },
};
</script>
<style scoped>
  .input_align{
      vertical-align: middle;
      text-align: center;
  }
  .input_align input{
    width: 60px;
    border-radius: 5px;
    border: 1px solid #ced4da;
  }
</style>
